"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _7JL3CCPEcjs = require('./7JL3CCPE.cjs');


var _PFM4PJSGcjs = require('./PFM4PJSG.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/dialog/dialog-disclosure.tsx
var _dom = require('@ariakit/core/utils/dom');
var _misc = require('@ariakit/core/utils/misc');
var TagName = "button";
var useDialogDisclosure = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useDialogDisclosure2({ store, ...props }) {
    const context = _PFM4PJSGcjs.useDialogProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "DialogDisclosure must receive a `store` prop or be wrapped in a DialogProvider component."
    );
    const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "contentElement");
    props = {
      "aria-haspopup": _dom.getPopupRole.call(void 0, contentElement, "dialog"),
      ...props
    };
    props = _7JL3CCPEcjs.useDisclosure.call(void 0, { store, ...props });
    return props;
  }
);
var DialogDisclosure = _PTOCUU2Dcjs.forwardRef.call(void 0, function DialogDisclosure2(props) {
  const htmlProps = useDialogDisclosure(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useDialogDisclosure = useDialogDisclosure; exports.DialogDisclosure = DialogDisclosure;
